export default __webpack_public_path__ + "static/Aime-BoldItalic-38d815bb4f0366fa392b4af17e99f891.woff2";